<!--经营信息-->
<template>
  <div class="operateInfo">
    <!--行政许可-->
    <div ref="businessInfos0" class="first-content">
      <div class="title-min SourceHanSansCN">行政许可<span class="quota">{{ administrationPermitTableData.length }}</span>
      </div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable30" :data="administrationPermitTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="decisionDate" title="决定日期/有效期自"/>
          <vxe-column field="endDate" title="截止日期/有效期至"/>
          <vxe-column field="documentNumber" title="许可文件编号/文书号"/>
          <vxe-column field="licenseFileName" title="许可文件名称"/>
          <vxe-column field="decisionOffice" title="决定/许可机关"/>
          <vxe-column field="licenseContent" title="许可内容"/>
          <vxe-column field="dataSources" title="数据来源"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="administrationPermitDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--招投标-->
    <div ref="businessInfos1" class="essential-content">
      <div class="title-min SourceHanSansCN">招投标<span class="quota">{{ biddingTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable31" :data="biddingTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="publicationDate" title="发布日期" width="120"/>
          <vxe-column field="title" title="标题"/>
          <vxe-column field="region" title="省份地区" width="100"/>
          <vxe-column field="announcementType" title="招标类型" width="100" align="center"/>
          <vxe-column field="biddingCompany" title="采购人"/>
          <vxe-column field="winningCompany" title="供应商"/>
          <vxe-column field="budgetAmount" title="中标金额" width="120" align="center"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="getBiddingDetails(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--进出口信用-->
    <div ref="businessInfos2" class="essential-content">
      <div class="title-min SourceHanSansCN">进出口信用<span class="quota">{{ creditTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable32" :data="creditTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="regTime" title="注册日期" width="120"/>
          <vxe-column field="name" title="注册海关"/>
          <vxe-column field="industryCategory" title="行业种类"/>
          <vxe-column field="businessCategory" title="经营类别"/>
          <vxe-column field="creditRating" title="信用等级"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="creditDetails(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--资质证书-->
    <div ref="businessInfos3" class="essential-content">
      <div class="title-min SourceHanSansCN">资质证书<span class="quota">{{ qualificationsCertificate.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable33" :data="qualificationsCertificate" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="dateIssue" title="发证日期" width="120"/>
          <vxe-column field="type" title="证书类型"/>
          <vxe-column field="name" title="产品名称及单元(主)"/>
          <vxe-column field="certificateNumber" title="证书编号"/>
          <vxe-column field="closingDate" title="截止日期" width="120"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="qualificationCertificateDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--双随机抽查-->
    <div ref="businessInfos4" class="essential-content">
      <div class="title-min SourceHanSansCN">双随机抽查<span class="quota">{{ randomCheckTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable34" :data="randomCheckTableData" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="planNumber" title="抽查计划编号" width="150"/>
          <vxe-column field="planName" title="抽查计划名称"/>
          <vxe-column field="taskNumber" title="抽查任务编号"/>
          <vxe-column field="taskName" title="抽查任务名称"/>
          <vxe-column field="type" title="抽查类型" width="100" align="center"/>
          <vxe-column field="office" title="抽查机关"/>
          <vxe-column field="completionDate" title="抽查完成日期" width="120"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="randomInspectionDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--产品信息-->
    <div ref="businessInfos5" class="essential-content">
      <div class="title-min SourceHanSansCN">产品信息<span class="quota">{{ productTableInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable35" :data="productTableInfo" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="productName" title="产品名称" width="150">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain"
                         v-if="row.productIcon!=null && row.productIcon!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && row.productIcon!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && row.productIcon!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && row.productIcon!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"
                         :src="row.productIcon" style="width: 60px;height: 60px;"/>
              <el-avatar shape="square" fit="contain" style="height: 60px;width: 60px;" v-else>
                <div class="legal" :style="'background:'+createRandomColor()+''">
                  <span v-for="(word,index) of logoword(row.productName)" class="logo-word"v-if="index<4">{{ word }}</span>
                </div>
              </el-avatar>
              <div class="avatar-title" style="padding-top: 15px;margin-left: 70px;">{{ row.productName }}</div>
            </template>
          </vxe-column>
          <vxe-column field="briefIntroduction" title="产品简介"></vxe-column>
          <vxe-column field="type" title="产品分类" width="200"></vxe-column>
          <vxe-column field="field" title="领域" width="200"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--税务评级-->
    <div ref="businessInfos6" class="essential-content">
      <div class="title-min SourceHanSansCN">税务评级<span class="quota">{{ taxRatingTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable36" :data="taxRatingTableData" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="year" title="评价年度" width="100"></vxe-column>
          <vxe-column field="creditRating" title="纳税人信用级别"></vxe-column>
          <vxe-column field="type" title="类型"></vxe-column>
          <vxe-column field="dutyNumber" title="纳税人识别号"></vxe-column>
          <vxe-column field="evaluationUnit" title="评价单位"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--购地信息-->
    <div ref="businessInfos7" class="essential-content">
      <div class="title-min SourceHanSansCN">购地信息<span class="quota">{{ landPurchaseInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable37" :data="landPurchaseInfo" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="projectLocation" title="项目位置"></vxe-column>
          <vxe-column field="landUse" title="土地用途" width="250"></vxe-column>
          <vxe-column field="landArea" title="土地面积(公顷)" width="150">
            <template #default="{row}"><span>{{ parseFloat(row.landArea) }}</span></template>
          </vxe-column>
          <vxe-column field="administrativeRegion" title="行政区" width="200"></vxe-column>
          <vxe-column field="modeLandSupply" title="供地方式" width="200"></vxe-column>
          <vxe-column field="dateSigning" title="合同签订日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="landPurchaseInfoDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--电信许可-->
    <div ref="businessInfos8" class="essential-content">
      <div class="title-min SourceHanSansCN">电信许可<span class="quota">{{ telegraphyPermitTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable38" :data="telegraphyPermitTableData" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="licenseKey" title="许可证号"></vxe-column>
          <vxe-column field="businessRange" title="业务及其覆盖范围"></vxe-column>
          <vxe-column field="effective" title="是否有效" width="100">
            <template #default="{ row }">
              <span>{{ row.effective == 1 ? '是' : '否' }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="telecomLicenseDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--供应商-->
    <div ref="businessInfos9" class="essential-content">
      <div class="title-min SourceHanSansCN">供应商<span class="quota">{{ supplierInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable39" :data="supplierInfo" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="supplierName" title="供应商"></vxe-column>
          <vxe-column field="proportion" title="采购占比">
            <template #default="{ row }">
              <span>{{ row.proportion > 0 ? row.proportion : '0%' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="purchaseAmount" title="采购金额">
            <template #default="{ row }">
              <span>{{ row.purchaseAmount > 0 ? row.purchaseAmount + '万元' : '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="reportingPeriod" title="报告期" width="120"></vxe-column>
          <vxe-column field="sources" title="数据来源" width="120"></vxe-column>
          <vxe-column field="association" title="关联关系" width="120"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--客户-->
    <div ref="businessInfos10" class="essential-content">
      <div class="title-min SourceHanSansCN">客户<span class="quota">{{ customerInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable40" :data="customerInfo" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="name" title="客户"></vxe-column>
          <vxe-column field="proportion" title="销售占比">
            <template #default="{ row }">
              <span>{{ row.proportion ? row.proportion + '%' : '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="purchaseAmount" title="销售金额">
            <template #default="{ row }">
              {{ row.purchaseAmount || '-' }}
            </template>
          </vxe-column>
          <vxe-column field="reportingPeriod" title="报告期" width="120"></vxe-column>
          <vxe-column field="sources" title="数据来源" width="120"></vxe-column>
          <vxe-column field="association" title="关联关系" width="120"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--地块公示-->
    <div ref="businessInfos11" class="essential-content">
      <div class="title-min SourceHanSansCN">地块公示<span class="quota">{{ plotPublicityTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable41" :data="plotPublicityTableData" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120"></vxe-column>
          <vxe-column field="siteLocation" title="地块位置"></vxe-column>
          <vxe-column field="administrativeRegion" title="行政区"></vxe-column>
          <vxe-column field="landArea" title="土地面积" width="200">
            <template #default="{ row }">
              <span>{{ row.landArea ? row.landArea + '公顷' : '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="landUse" title="土地用途" width="120"></vxe-column>
          <vxe-column field="office" title="发布机关" width="150"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="plotPublicityDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--财务解析-->
    <div ref="businessInfos12" class="essential-content">
      <div class="title-min SourceHanSansCN">财务解析<span class="quota"
                                                       v-if="financialAnalysisInfo!='' && financialAnalysisInfo!=null && financialAnalysisInfo!=undefined">1</span>
      </div>
      <div class="table-menu"
           v-if="financialAnalysisInfo!='' && financialAnalysisInfo!=null && financialAnalysisInfo!=undefined">
        <el-row>
          <el-col :span="4" class="col-8">利润表</el-col>
          <el-col :span="4" class="col-8" v-for="financial in financialAnalysisInfo">{{ financial.year }}年</el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">营业收入</el-col>
          <el-col :span="4" class="col-9" v-for="financial1 in financialAnalysisInfo">{{ financial1.businessIncome }}亿
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">净利润</el-col>
          <el-col :span="4" class="col-9" v-for="financial2 in financialAnalysisInfo">{{ financial2.netProfit }}亿
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">总资产</el-col>
          <el-col :span="4" class="col-9" v-for="financial3 in financialAnalysisInfo">{{ financial3.totalAssets }}亿
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">净资产</el-col>
          <el-col :span="4" class="col-9" v-for="financial4 in financialAnalysisInfo">{{ financial4.netAssets }}亿
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">净利率</el-col>
          <el-col :span="4" class="col-9" v-for="financial5 in financialAnalysisInfo">
            {{ financial5.netInterestRate }}%
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="col-8">毛利率</el-col>
          <el-col :span="4" class="col-9" v-for="financial6 in financialAnalysisInfo">
            {{ financial6.grossProfitMargin }}%
          </el-col>
        </el-row>
      </div>
      <div class="none-content" v-else>暂无财务解析数据</div>
    </div>
    <!--土地转让-->
    <div ref="businessInfos13" class="essential-content">
      <div class="title-min SourceHanSansCN">土地转让<span class="quota">{{ landTransferTableData.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable42" :data="landTransferTableData" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="成交时间" title="成交日期" width="120"></vxe-column>
          <vxe-column field="宗地坐落" title="土地坐落"></vxe-column>
          <vxe-column field="土地面积(公顷)" title="土地面积" width="150">
            <template #default="{ row }">
              <span>{{ row['土地面积(公顷)'] ? row['土地面积(公顷)'] + '公顷' : '-' }}</span>
            </template>
          </vxe-column>
          <vxe-column field="原土地使用权人" title="原土地使用权人"></vxe-column>
          <vxe-column field="现土地使用权人" title="现土地使用权人"></vxe-column>
          <vxe-column field="转让价格(万元)" title="转让价格" width="150">
            <template #default="{ row }">
              <span>{{ row['转让价格(万元)'] ? row['转让价格(万元)'] + '万元' : '' }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="landTransferDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--公告研报-->
    <div ref="businessInfos14" class="essential-content">
      <div class="title-min SourceHanSansCN">公告研报</div>
      <div class="table-menu">
        <div class="result-left">相关公告</div>
        <vxe-table resizable border ref="xTable43" :data="researchReport.noticeInfo" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120"></vxe-column>
          <vxe-column field="type" title="发布类型" width="120"></vxe-column>
          <vxe-column field="content" title="公告内容">
            <template #default="{ row }">
              <el-link @click="seePDF(row.url)" type="primary" :underline="false">{{ row.content }}</el-link>
            </template>
          </vxe-column>
        </vxe-table>
        <div class="result-left2">企业研报</div>
        <vxe-table resizable border ref="xTable44" :data="researchReport.enterpriseReport" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120"></vxe-column>
          <vxe-column field="type" title="发布类型" width="120"></vxe-column>
          <vxe-column field="content" title="研报内容">
            <template #default="{ row }">
              <el-link @click="seePDF(row.url)" type="primary" :underline="false">{{ row.content }}</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--抽查检查-->
    <div ref="businessInfos15" class="essential-content">
      <div class="title-min SourceHanSansCN">抽查检查<span class="quota">{{ spotCheck.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable45" :data="spotCheck" align="left"
                   class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="inspectionDate" title="日期"></vxe-column>
          <vxe-column field="inspectType" title="类型"></vxe-column>
          <vxe-column field="result" title="结果"></vxe-column>
          <vxe-column field="inspectionOrganization" title="检查实施机关"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--PDF文件预览-->
    <el-dialog title="预览" :visible.sync="dialog_pdf" top="0px" width="100%" style="z-index: 9999">
      <div :style="'height:'+dialogHeight+'px;'">
        <iframe style="width: 100%;height: 100%" :src="pdfSrc"/>
      </div>
    </el-dialog>
    <!--行政许可详情-->
    <el-dialog title="行政许可详情" :visible.sync="Dialog27" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">决定书文号</td>
          <td class="col-td3">{{ LicensingDetails.documentNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">审核类型</td>
          <td class="col-td3">{{ LicensingDetails.auditType || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">法定代表人</td>
          <td class="col-td3">{{ LicensingDetails.legalRepresentative || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">许可内容</td>
          <td class="col-td3">{{ LicensingDetails.licenseContent || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">许可有效期</td>
          <td class="col-td3">{{ LicensingDetails.validityDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">许可决定日期</td>
          <td class="col-td3">{{ LicensingDetails.decisionDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">许可截止日期</td>
          <td class="col-td3">{{ LicensingDetails.endDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">地方编码</td>
          <td class="col-td3">{{ LicensingDetails.placeCode || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">决定机关</td>
          <td class="col-td3">{{ LicensingDetails.decisionOffice || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--招投标详情-->
    <el-dialog title="招投标详情" :visible.sync="Dialog37" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">标题</td>
          <td class="col-td3">{{ BiddingDetail.title || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">公布日期</td>
          <td class="col-td3">{{ BiddingDetail.publicationDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">公布类型</td>
          <td class="col-td3">{{ BiddingDetail.announcementType || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">地域</td>
          <td class="col-td3">{{ BiddingDetail.region || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">工程号</td>
          <td class="col-td3">{{ BiddingDetail.projectNo || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">招标代理公司</td>
          <td class="col-td3">{{ BiddingDetail.biddingAgency || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">招标公司</td>
          <td class="col-td3">{{ BiddingDetail.biddingCompany || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">中标公司</td>
          <td class="col-td3">
            <el-link type="primary" :underline="false">{{ BiddingDetail.winningCompany || '-' }}</el-link>
          </td>
        </tr>
        <tr>
          <td class="col-td1">中标候选公司</td>
          <td class="col-td3">{{ BiddingDetail.bidWinningCandidateCompany || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">关联公司</td>
          <td class="col-td3">
            <div
                v-if="BiddingDetail.affiliatedCompanies!='' && BiddingDetail.affiliatedCompanies!=null && BiddingDetail.affiliatedCompanies!=undefined">
              <div v-for="affiliatedCompanies in BiddingDetail.affiliatedCompanies">
                <div>
                  <span>{{ affiliatedCompanies.key }}：</span>
                  <el-link type="primary" :underline="false">{{ affiliatedCompanies.value }}</el-link>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </el-dialog>
    <!--进出口信用详情-->
    <el-dialog title="进出口信用详情" :visible.sync="Dialog30" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">海关注册编码</td>
          <td class="col-td2">{{ exportCreditDetail.regNumber || '-' }}</td>
          <td class="col-td1">注册海关</td>
          <td class="col-td2">{{ exportCreditDetail.name || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">行政区划</td>
          <td class="col-td2">{{ exportCreditDetail.administrative || '-' }}</td>
          <td class="col-td1">经济区划</td>
          <td class="col-td2">{{ exportCreditDetail.economicDivision || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">经营类别</td>
          <td class="col-td2">{{ exportCreditDetail.businessCategory || '-' }}</td>
          <td class="col-td1">行业种类</td>
          <td class="col-td2">{{ exportCreditDetail.industryCategory || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">海关注销标志</td>
          <td class="col-td2">{{ exportCreditDetail.cancel || '-' }}</td>
          <td class="col-td1">年报情况</td>
          <td class="col-td2">{{ exportCreditDetail.annualReport || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">注册日期</td>
          <td class="col-td2">{{ exportCreditDetail.regTime || '-' }}</td>
          <td class="col-td1">报关有效期</td>
          <td class="col-td2">{{ exportCreditDetail.termTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">特殊贸易区域</td>
          <td class="col-td2">{{ exportCreditDetail.specialTradeArea || '-' }}</td>
          <td class="col-td1">信用等级</td>
          <td class="col-td2">{{ exportCreditDetail.creditRating || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">跨境贸易电子商务类型</td>
          <td class="col-td2" style="width: 85%;">-</td><!--NoticeDetails.businessType ||-->
        </tr>
      </table>
    </el-dialog>
    <!--资质证书详情-->
    <el-dialog title="资质证书详情" top="10px" :visible.sync="Dialog29" width="60%" style="z-index: 9999">
      <el-table :data="CertificateDetail" border :show-header="false" :cell-style="columnStyle">
        <el-table-column prop="title" label="日期" width="250"></el-table-column>
        <el-table-column prop="content" label="姓名"></el-table-column>
      </el-table>
    </el-dialog>
    <!--双随机抽查详情-->
    <el-dialog title="双随机抽查详情" :visible.sync="Dialog23" top="10px" style="z-index: 9999">
      <div class="dialog-el-table">
        <el-table :data="doubleRandomSampe" border :height="dialogHeight">
          <el-table-column prop="checkItem" label="检查事项"></el-table-column>
          <el-table-column prop="checkResult" label="检查结果"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <!--购地信息详情-->
    <el-dialog title="购地信息详情" top="10px" :visible.sync="Dialog28" width="70%" style="z-index: 9999;">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">行政区</td>
          <td class="col-td2">{{ landPurchaseDetails.administrativeRegion || '-' }}</td>
          <td class="col-td1">电子监管号</td>
          <td class="col-td2">{{ landPurchaseDetails.regulatoryNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">项目名称</td>
          <td class="col-td2">{{ landPurchaseDetails.projectName || '-' }}</td>
          <td class="col-td1">项目位置</td>
          <td class="col-td2">{{ landPurchaseDetails.projectLocation || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">面积</td>
          <td class="col-td2">{{ landPurchaseDetails.landArea || '-' }}</td>
          <td class="col-td1">土地资源</td>
          <td class="col-td2">{{ landPurchaseDetails.landResource || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地用途</td>
          <td class="col-td2">{{ landPurchaseDetails.landUse || '-' }}</td>
          <td class="col-td1">供地方式</td>
          <td class="col-td2">{{ landPurchaseDetails.modeLandSupply || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地使用年限</td>
          <td class="col-td2" v-if="landPurchaseDetails.serviceLife">{{ landPurchaseDetails.serviceLife }}年</td>
          <td class="col-td2" v-else>-</td>
          <td class="col-td1">行业分类</td>
          <td class="col-td2">{{ landPurchaseDetails.industryClassification || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地级别</td>
          <td class="col-td2">{{ landPurchaseDetails.landGrade || '-' }}</td>
          <td class="col-td1">成交价格</td>
          <td class="col-td2" v-if="landPurchaseDetails.transactionPrice">{{
              landPurchaseDetails.transactionPrice || '-'
            }}万元
          </td>
          <td class="col-td2">-</td>
        </tr>
        <tr>
          <td class="col-td1">土地使用权人</td>
          <td class="col-td2">{{ landPurchaseDetails.companyName || '-' }}</td>
          <td class="col-td1">约定交地时间</td>
          <td class="col-td2">{{ landPurchaseDetails.committedTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">约定开工时间</td>
          <td class="col-td2">{{ landPurchaseDetails.commencementTime || '-' }}</td>
          <td class="col-td1">约定竣工时间</td>
          <td class="col-td2">{{ landPurchaseDetails.completionTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">实际动工时间</td>
          <td class="col-td2">{{ landPurchaseDetails.actualCommencementTime || '-' }}</td>
          <td class="col-td1">实际竣工时间</td>
          <td class="col-td2">{{ landPurchaseDetails.actualCompletionTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">批准单位</td>
          <td class="col-td2">{{ landPurchaseDetails.approved || '-' }}</td>
          <td class="col-td1">合同签订日期</td>
          <td class="col-td2">{{ landPurchaseDetails.dateSigning || '-' }}</td>
        </tr>
      </table>
      <div class="small-title">分期支付约定</div>
      <table class="dialog-table" style="width:100%" v-for="payment in landPurchaseDetails.payment">
        <tr>
          <td class="col-td1">支付期号</td>
          <td class="col-td2">{{ payment.pay_number || '-' }}</td>
          <td class="col-td1">约定支付日期</td>
          <td class="col-td2">{{ payment.pay_date || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">约定支付金额</td>
          <td class="col-td2">{{ payment.pay_amount || '-' }}</td>
          <td class="col-td1">备注</td>
          <td class="col-td2">{{ payment.pay_notes || '-' }}</td>
        </tr>
      </table>
      <div class="small-title">约定容积率</div>
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">下限</td>
          <td class="col-td2">{{ landPurchaseDetails.plotRatio.lower_limit || '-' }}</td>
          <td class="col-td1">上限</td>
          <td class="col-td2">{{ landPurchaseDetails.plotRatio.upper_limit || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--电信许可详情-->
    <el-dialog title="电信许可详情" :visible.sync="Dialog26" style="z-index: 9999">
      <div class="small-title" style="padding: 0px 0px 10px;">基本信息</div>
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">公司名称</td>
          <td class="col-td2">{{ telecomPermitDetail.corporateName || '-' }}</td>
          <td class="col-td1">许可证号</td>
          <td class="col-td2">{{ telecomPermitDetail.licenseKey || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">是否有效</td>
          <td class="col-td2" v-if="telecomPermitDetail.effective==1">是</td>
          <td class="col-td2" v-else>否</td>
          <td class="col-td1">业务及其覆盖范围</td>
          <td class="col-td2">{{ telecomPermitDetail.businessRange || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--地块公示详情-->
    <el-dialog title="地块公示详情" :visible.sync="Dialog25" width="65%" style="z-index: 9999">
      <div class="small-title" style="padding: 0px 0px 10px;">地块基本信息</div>
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">宗地编号</td>
          <td class="col-td2">{{ landPublicityDetail.parcelNumber || '-' }}</td>
          <td class="col-td1">地块位置</td>
          <td class="col-td2">{{ landPublicityDetail.siteLocation || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地面积</td>
          <td class="col-td2" v-if="landPublicityDetail.landArea">{{ landPublicityDetail.landArea }}公顷</td>
          <td class="col-td2" v-else>-</td>
          <td class="col-td1">土地用途</td>
          <td class="col-td2">{{ landPublicityDetail.landUse || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">项目名称</td>
          <td class="col-td2">{{ landPublicityDetail.entryName || '-' }}</td>
          <td class="col-td1">受让单位</td>
          <td class="col-td2">{{ landPublicityDetail.transferees || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">备注</td>
          <td class="col-td2">{{ landPublicityDetail.remarks || '-' }}</td>
          <td class="col-td1">公示期</td>
          <td class="col-td2">{{ landPublicityDetail.publicityPeriod || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">发布机关</td>
          <td class="col-td2">{{ landPublicityDetail.office || '-' }}</td>
          <td class="col-td1">发布日期</td>
          <td class="col-td2">{{ landPublicityDetail.dateIssue || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">意见反馈方式</td>
          <td class="col-td2" style="width: 85%;">{{ landPublicityDetail.feedback || '-' }}</td>
        </tr>
      </table>
      <div class="small-title">联系方式</div>
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">联系单位</td>
          <td class="col-td2">{{ landPublicityDetail.contactUnit || '-' }}</td>
          <td class="col-td1">单位地址</td>
          <td class="col-td2">{{ landPublicityDetail.contactAddress || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">邮政编码</td>
          <td class="col-td2">{{ landPublicityDetail.postalCode || '-' }}</td>
          <td class="col-td1">联系电话</td>
          <td class="col-td2">{{ landPublicityDetail.contactTel || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">联系人</td>
          <td class="col-td2">{{ landPublicityDetail.contacts || '-' }}</td>
          <td class="col-td1">电子邮件</td>
          <td class="col-td2">{{ landPublicityDetail.email || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--土地转让详情-->
    <el-dialog title="土地转让详情" :visible.sync="Dialog24" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">宗地标识</td>
          <td class="col-td2">{{ landTransferDetailInfo['宗地标识'] || '-' }}</td>
          <td class="col-td1">宗地编号</td>
          <td class="col-td2">{{ landTransferDetailInfo['宗地编号'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">宗地座落</td>
          <td class="col-td2">{{ landTransferDetailInfo['宗地坐落'] || '-' }}</td>
          <td class="col-td1">所在行政区</td>
          <td class="col-td2">{{ landTransferDetailInfo['所在行政区'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地用途</td>
          <td class="col-td2">{{ landTransferDetailInfo['土地用途'] || '-' }}</td>
          <td class="col-td1">原土地使用权人</td>
          <td class="col-td2">{{ landTransferDetailInfo['原土地使用权人'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">现土地使用权人</td>
          <td class="col-td2">{{ landTransferDetailInfo['现土地使用权人'] || '-' }}</td>
          <td class="col-td1">土地面积（公顷）</td>
          <td class="col-td2">{{ landTransferDetailInfo['土地面积(公顷)'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">成交日期</td>
          <td class="col-td2">{{ landTransferDetailInfo['成交时间'] || '-' }}</td>
          <td class="col-td1">土地使用权类型</td>
          <td class="col-td2">{{ landTransferDetailInfo['土地使用权类型'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地使用年限</td>
          <td class="col-td2" v-if="landTransferDetailInfo['土地使用年限']">{{ landTransferDetailInfo['土地使用年限'] }}年</td>
          <td class="col-td2" v-else>-</td>
          <td class="col-td1">土地利用状况</td>
          <td class="col-td2">{{ landTransferDetailInfo['土地利用状况'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">土地级别</td>
          <td class="col-td2">{{ landTransferDetailInfo['土地级别'] || '-' }}</td>
          <td class="col-td1">转让方式</td>
          <td class="col-td2">{{ landTransferDetailInfo['转让方式'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">转让价格（万元）</td>
          <td class="col-td2" style="width: 85%;">{{ landTransferDetailInfo['转让价格(万元)'] || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import {
  administrativeLicensingChina,
  administrativeLicensingChinaDetails,
  getBiddingInfo,
  BiddingDetails,
  importExportCredit,
  importExportCreditDetails,
  qualificationCertificate,
  qualificationCertificateDetails,
  doubleRandomSampling,
  doubleRandomSamplingDetails,
  productInformation,
  getTaxRating,
  landPurchaseInformation,
  landPurchaseInformationDetails,
  getTelecomPermit,
  getTelecomPermitDetails,
  getSupplier,
  getCustomer,
  landPublicity,
  landPublicityDetails,
  financialAnalysis,
  landTransfer,
  landTransferDetails,
  relevantNotice,
  researchReport,
  DdSpotCheck
} from '@/api/enterpriseDetailsApi'

Vue.use(VXETable)
export default {
  name: "operateInfo",
  components: {page},
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      /*行政许可*/
      administrationPermitTableData: [],
      /*招投标*/
      biddingTableData: [],
      /*进出口信用*/
      creditTableData: [],
      /*资质证书*/
      qualificationsCertificate: [],
      /*双随机抽查*/
      randomCheckTableData: [],
      /*产品信息*/
      productTableInfo: [],
      /*税务评级*/
      taxRatingTableData: [],
      /*购地信息*/
      landPurchaseInfo: [],
      /*电信许可*/
      telegraphyPermitTableData: [],
      /*供应商*/
      supplierInfo: [],
      /*客户*/
      customerInfo: [],
      /*地块公示*/
      plotPublicityTableData: [],
      /*财务解析*/
      financialAnalysisInfo: [],
      /*土地转让*/
      landTransferTableData: [],
      /*公告研报*/
      researchReport: {
        noticeInfo: [],
        enterpriseReport: []
      },
      /*PDF预览*/
      dialog_pdf: false,
      Dialog27: false,
      Dialog37: false,
      Dialog30: false,
      Dialog29: false,
      Dialog23: false,
      Dialog28: false,
      Dialog26: false,
      Dialog25: false,
      Dialog24: false,
      pdfSrc: '',
      dialogHeight: document.documentElement.clientHeight - 130,
      /*抽查检查*/
      spotCheck: [],
      /*行政许可详情*/
      LicensingDetails: {},
      /*招投标详情*/
      BiddingDetail: {},
      /*进出口信用详情*/
      exportCreditDetail: {},
      /*资质证书详情*/
      CertificateDetail: {},
      /*双随机抽查详情*/
      doubleRandomSampe: {},
      gheight: 500,
      /*购地信息详情*/
      landPurchaseDetails: {plotRatio: {lower_limit: '', upper_limit: ''}},
      /*电信许可详情*/
      telecomPermitDetail: {},
      /*地块公示详情*/
      landPublicityDetail: {},
      /*土地转让详情*/
      landTransferDetailInfo: []
    }
  },
  computed: {
    logoword() {
      return function (word) {
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  methods: {
    /*随机生成颜色值*/
    createRandomColor() {
      let num = Math.floor(Math.random() * 9 + 1);
      let colorList = ['#7db3d9', '#d1ae9d', '#ca8484', '#bc9edd', '#8B658B', '#B22222', '#27408B', '#008B8B', '#5D478B', '#68228B'];
      console.log(colorList[num])
      return colorList[num];
    },
    /*行政许可*/
    getAdministrativeLicensingChina() {
      administrativeLicensingChina({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.administrationPermitTableData = res.content.rows;
        }
      })
    },
    /*行政许可详情*/
    administrationPermitDetail(row) {
      administrativeLicensingChinaDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.LicensingDetails = res.content;
          this.Dialog27 = true;
        }
      })
    },
    /*招投标*/
    getBiddingInfoBase() {
      getBiddingInfo({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.biddingTableData = res.content.rows;
        }
      })
    },
    /*招投标详情*/
    getBiddingDetails(row) {
      BiddingDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.BiddingDetail = res.content;
          this.BiddingDetail.affiliatedCompanies = JSON.parse(this.BiddingDetail.affiliatedCompanies.replace("\\u005c", ""));
          this.Dialog37 = true;
        }
      })
    },
    /*进出口信用*/
    getImportExportCredit() {
      importExportCredit({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.creditTableData = res.content.content.rows;
        }
      })
    },
    /*进出口信用详情*/
    creditDetails(row) {
      importExportCreditDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.exportCreditDetail = res.content;
          this.Dialog30 = true;
        }
      })
    },
    /*资质证书*/
    getQualificationCertificate() {
      qualificationCertificate({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.qualificationsCertificate = res.content.rows;
        }
      })
    },
    /*资质证书详情*/
    qualificationCertificateDetail(row) {
      qualificationCertificateDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          /*if (res.content.indexOf("\\u005c")>-1){
            this.CertificateDetail = JSON.parse(res.content.replace("\\u005c", "")).result;
            this.Dialog29 = true;
          }else{*/
          this.CertificateDetail = res.content.result;
          this.Dialog29 = true;
          // }
        }
      })
    },
    /*双随机抽查*/
    getDoubleRandomSampling() {
      doubleRandomSampling({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.randomCheckTableData = res.content.rows;
        }
      })
    },
    /*双随机抽查详情*/
    randomInspectionDetail(row) {
      doubleRandomSamplingDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.doubleRandomSampe = JSON.parse(res.content.detailData.replace(/\'/g, '"')).result;
          this.Dialog23 = true;
          this.gheight = document.documentElement.clientHeight - 200;
        }
      })
    },
    /*产品信息*/
    getProductInformation() {
      productInformation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.productTableInfo = res.content.rows;
        }
      })
    },
    /*税务评级*/
    getTaxRatingBase() {
      getTaxRating({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.taxRatingTableData = res.content.rows;
        }
      })
    },
    /*购地信息*/
    getLandPurchaseInformation() {
      landPurchaseInformation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.landPurchaseInfo = res.content.rows;
        }
      })
    },
    /*购地信息详情*/
    landPurchaseInfoDetail(row) {
      landPurchaseInformationDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          if (res.content.payment != '' && res.content.payment != undefined && res.content.payment != null) {
            res.content.payment = JSON.parse(res.content.payment.replace("\\u005c", ""));
          }
          if (res.content.plotRatio != '' && res.content.plotRatio != undefined && res.content.plotRatio != null) {
            res.content.plotRatio = JSON.parse(res.content.plotRatio.replace("\\u005c", ""));
          }
          this.landPurchaseDetails = res.content;
          this.Dialog28 = true;
        }
      })
    },
    /*电信许可*/
    getTelecomPermitBase() {
      getTelecomPermit({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.telegraphyPermitTableData = res.content.rows;
        }
      })
    },
    /*电信许可详情*/
    telecomLicenseDetail(row) {
      getTelecomPermitDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.telecomPermitDetail = res.content;
          this.Dialog26 = true;
        }
      })
    },
    /*供应商*/
    getSupplierBase() {
      getSupplier({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.supplierInfo = res.content.rows;
        }
      })
    },
    /*客户*/
    getCustomerBase() {
      getCustomer({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.customerInfo = res.content.rows;
        }
      })
    },
    /*地块公示*/
    getLandPublicity() {
      landPublicity({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.plotPublicityTableData = res.content.rows;
        }
      })
    },
    /*地块公示详情*/
    plotPublicityDetail(row) {
      landPublicityDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.landPublicityDetail = res.content;
          this.Dialog25 = true;
        }
      })
    },
    /*财务解析*/
    getFinancialAnalysis() {
      financialAnalysis({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.financialAnalysisInfo = res.content;
        }
      })
    },
    /*土地转让*/
    getLandTransfer() {
      landTransfer({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          let info = res.content.rows;
          this.landTransferTableData = [];
          info.forEach(function (row, index) {
            let list = {
              id: row.id, '宗地坐落': '', '原土地使用权人': '', '现土地使用权人': '', '宗地标识': '',
              '宗地编号': '', '所在行政区': '', '土地级别': '', '土地面积(公顷)': '', '土地用途': '', '土地使用权类型': '',
              '土地使用年限': '', '土地利用状况': '', '转让方式': '', '转让价格(万元)': '', '成交时间': ''
            }
            row.transfer_details.forEach(function (items, index) {
              list[items.key] = items.value;
            })
            this.landTransferTableData.push(list);
          })
        }
      })
    },
    /*土地转让详情*/
    landTransferDetail(row) {
      landTransferDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          let info = res.content;
          this.landTransferDetailInfo = [];
          let list = {
            '宗地坐落': '',
            '原土地使用权人': '',
            '现土地使用权人': '',
            '宗地标识': '',
            '宗地编号': '',
            '所在行政区': '',
            '土地级别': '',
            '土地面积(公顷)': '',
            '土地用途': '',
            '土地使用权类型': '',
            '土地使用年限': '',
            '土地利用状况': '',
            '转让方式': '',
            '转让价格(万元)': '',
            '成交时间': ''
          }
          info.forEach(function (row, index) {
            list[row.key] = row.value;
          })
          this.landTransferDetailInfo = list;
          this.Dialog24 = true;
        }
      })
    },
    /*公告研报*/
    getAnnouncementResearchReport() {
      /*相关公告*/
      relevantNotice({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.researchReport.noticeInfo = res.content.rows;
        }
      })
      /*企业研报*/
      researchReport({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.researchReport.enterpriseReport = res.content.rows;
        }
      })
    },
    /*抽查检查*/
    getDdSpotCheck() {
      DdSpotCheck({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.spotCheck = res.content.rows;
        }
      })
    },
    /*PDF文件预览*/
    seePDF(url) {
      if (url != '' && url != null && url != undefined) {
        this.pdfSrc = url;
        this.dialog_pdf = true;
      } else {
        this.$message({message: '暂无展现数据！', type: 'warning'});
      }
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    },
    /*动态修改列样式*/
    columnStyle({columnIndex}) {
      if (columnIndex == 0) {
        return "background:#D6E9FF;color:#333333;";
      }
    },
  },
  mounted() {
    this.getAdministrativeLicensingChina();
    this.getBiddingInfoBase();
    this.getImportExportCredit();
    this.getQualificationCertificate();
    this.getDoubleRandomSampling();
    this.getProductInformation();
    this.getTaxRatingBase();
    this.getLandPurchaseInformation();
    this.getTelecomPermitBase();
    this.getSupplierBase();
    this.getCustomerBase();
    this.getLandPublicity();
    this.getFinancialAnalysis();
    this.getLandTransfer();
    this.getAnnouncementResearchReport();
    this.getDdSpotCheck();
  }
}
</script>
<style scoped>
.operateInfo >>> .el-dialog__wrapper .el-dialog .el-dialog__body {
  padding: 10px 20px 20px;
  color: #333333;
}

.operateInfo >>> .dialog-el-table .el-table th.el-table__cell {
  background-color: #D6E9FF !important;
  color: #333333;
}

.operateInfo >>> .dialog-el-table .el-table {
  color: #333333 !important;
}
</style>
<style lang="scss" scoped>
.operateInfo {
  .first-content {
    background: white;
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .span-red {
      color: #FE273B;
      font-weight: bold
    }

    .el-row-lightblue {
      background: #F1F7FC;
      padding: 30px 0px;
      text-align: center;
      margin: 0px 30px 10px;
    }

    .result-left {
      margin-bottom: 15px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .result-left2 {
      margin-bottom: 15px;
      margin-top: 30px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .col-8 {
      text-align: left;
      background: #F3F9FC;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }

    .col-9 {
      text-align: left;
      background: #ffffff;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }
  }

  .quota {
    padding-left: 10px;
    color: #2B79FE;
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }

  .legal {
    height: 60px;
    width: 60px;
    font-size: 18px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .el-avatar {
    background: white;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: 6px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
    color: #333333;
  }

  .avatar-title {
    text-align: left;
    color: #333333;
    padding-top: 10px;
    line-height: revert;
  }

  .small-title {
    font-size: 16px;
    color: #333333;
    text-align: left;
    padding: 30px 0px 10px;
    font-weight: 500;
  }

  .none-content {
    margin: 10px 30px 20px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid #EEEEEE;
    background: #ffffff;
  }

  .dialog-table {
    table-layout: fixed;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    border-spacing: 0px;
    border-color: grey;

    tr {
      border-spacing: 0px;
    }

    .col-td1 {
      padding: 15px 10px 15px 20px;
      background: #D6E9FF;
      text-align: left;
      color: #333333;
      width: 150px;
      border-spacing: 0px;
    }

    .col-td2 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      max-width: 35%;
      border-spacing: 0px;
    }

    .col-td3 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: auto;
      border-spacing: 0px;
      word-wrap: break-word;
    }
  }

  .el-dialog__wrapper {
    z-index: 9999 !important;
  }
  .table-menu {
    padding: 0px 0px 20px;
  }

  .table-x-table {
    margin: 0px 30px;
    border: 0.5pt solid #e5eef6;
  }
}
</style>